export const volumes = [
  {
    title: 'Volumen 1 — Claves para Comprender la Información sobre Epilepsia™',
    border: 'border-blue-400/30',
    items: [
      'Entendés qué significan términos médicos sin interpretar el caso de tu hijo',
      'Diferenciás información general de información individual',
      'Detectás cuándo una palabra necesita más contexto para ser clara',
      'Creás tu propio diccionario de términos que aparecen constantemente',
      'Lográs leer explicaciones médicas sin quedarte estancada en palabras difíciles'
    ]
  },
  {
    title: 'Volumen 2 — Criterios para Evaluar la Información Médica™',
    border: 'border-green-400/30',
    items: [
      'Desarrollás criterio para revisar contenido de Internet y redes sociales',
      'Separás un testimonio de una ley médica universal',
      'Detectás señales de alerta: promesas exageradas, miedo, presión',
      'Evitás que el contenido alarmista aumente tu preocupación',
      'Guardás información confiable sin perder tiempo en lo que no sirve'
    ]
  },
  {
    title: 'Volumen 3 — Método para Transformar Dudas en Preguntas Médicas™',
    border: 'border-amber-400/30',
    items: [
      'Convertís dudas vagas en preguntas concretas y claras',
      'Organizás tus preguntas por orden de lo que más necesitás aclarar',
      'Transformás tus dudas en preguntas específicas para el equipo médico',
      'Convertís las explicaciones que recibís en nuevas preguntas cuando algo no queda claro',
      'Construís tu propio sistema de preguntas que podés reutilizar'
    ]
  }
] as const;

export const bonuses = [
  {
    number: '01',
    title: 'Filtro de Información Confiable™',
    value: '$8.500',
    details: [
      'Herramienta rápida para revisar cualquier información antes de darle peso',
      'Semáforo de información y checklist de señales de alerta',
      'Versión ultrarrápida para consultar desde el celular'
    ]
  },
  {
    number: '02',
    title: 'Diccionario Materno de Términos Médicos™',
    value: '$7.200',
    details: [
      'Tu cuaderno personal para registrar las palabras difíciles',
      'Método de 4 pasos para bajarlas a preguntas simples',
      'Banco inicial de términos para arrancar hoy'
    ]
  },
  {
    number: '03',
    title: 'Mapa de Dudas Prioritarias™',
    value: '$6.800',
    details: [
      'Descargá tu cabeza: ordená todas las dudas acumuladas',
      'Clasificalas por tipo y priorizá qué aclarar primero',
      'Sin presión y sin sentir que te olvidás de algo'
    ]
  },
  {
    number: '04',
    title: 'Traductor de Testimonios y Consejos™',
    value: '$6.500',
    details: [
      'Escuchá experiencias ajenas sin convertirlas en decisiones automáticas',
      'Separá experiencia, consejo, opinión e indicación ajena',
      'Reducís la confusión que dejan los grupos y las redes.'
    ]
  },
  {
    number: '05',
    title: 'Mini Rutina Anticaos de Información™',
    value: '$5.900',
    details: [
      'Ritual semanal de 15 minutos para ordenar la información nueva',
      'Sistema de 4 destinos para cada cosa que te llega',
      'Nada vuelve a quedar acumulado en tu cabeza'
    ]
  }
] as const;
